import {
  type ShapedComponent,
  type ShapePoint,
  shapeHolesOf,
  shapeRingOf,
} from '@repo/api-contracts';

const subpathOf = (ring: readonly ShapePoint[], pxPerMmX: number, pxPerMmY: number) =>
  `${ring
    .map(
      (point, index) =>
        `${index === 0 ? 'M' : 'L'} ${point.xMm * pxPerMmX} ${point.yMm * pxPerMmY}`,
    )
    .join(' ')} Z`;

/**
 * 인쇄 영역 모양을 SVG 경로로 바꾼다. 바깥 고리 뒤에 구멍마다 서브패스를 잇는다(evenodd 로 그린다).
 * 가로·세로 축척이 다르면(사진 위 자리에 맞춰 늘인 보기) 축마다 따로 곱한다 — 세로를 빼면 두 축이 같다.
 */
export const areaShapePathOf = (
  component: ShapedComponent,
  pxPerMmX: number,
  pxPerMmY: number = pxPerMmX,
): string =>
  [shapeRingOf(component), ...shapeHolesOf(component)]
    .map((ring) => subpathOf(ring, pxPerMmX, pxPerMmY))
    .join(' ');
